import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import FilterBar from '../FilterBar';
import { programColumn } from '../../utils/columnConfigs/baseColumns';

function getColumns(sortConfig, onSortColumn, showProgramNameColumn) {
  return _.compact([
    {
      label: 'Sending organization',
      sortColumn: 'referred_by_group.name',
    },
    {
      label: 'Client Name',
      sortColumn: 'contact.full_name',
    },
    {
      label: 'Service Type',
      sortColumn: 'service_type.name',
    },
    showProgramNameColumn ? programColumn('referred_to_program.name', sortConfig, onSortColumn) : null,
    {
      label: 'Date Received',
      sortColumn: 'received_at',
      type: 'date',
      align: 'left',
      sortBy: sortConfig?.sidx,
      sortDirection: sortConfig.sord,
      setSort: ({ sortBy }) => onSortColumn(sortBy),
    },
    {
      label: 'Last Updated',
      sortColumn: 'updated_at',
      type: 'date',
      sortBy: sortConfig?.sidx,
      sortDirection: sortConfig.sord,
      setSort: ({ sortBy }) => onSortColumn(sortBy),
    },
  ]);
}

export default function ReferralsInReviewIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    filters,
    onFiltersChange,
    fetchGroupsUsers,
    sortConfig,
    setSort,
    showProgramNameColumn,
  } = props;

  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="Referrals in review"
                id="referrals-in-review-table"
                dataSet={data}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns(sortConfig, setSort, showProgramNameColumn)}
                emptyMessage="There are no referrals in review."
                rowIcon={(referral) => <ReferralRowIcon referral={referral} />}
              />
            )
        }
      </div>
    </div>
  );
}

ReferralsInReviewIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  fetchGroupsUsers: PropTypes.func.isRequired,
  sortConfig: PropTypes.object.isRequired,
  setSort: PropTypes.func.isRequired,
  showProgramNameColumn: PropTypes.bool,
};

ReferralsInReviewIndex.defaultProps = {
  showProgramNameColumn: false,
};
